"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const preact_1 = require("preact");
function Alert(props) {
    let cls = "alert" + (props.title ? " big" : "");
    if (props.type) {
        cls += " " + props.type;
    }
    if (props.class) {
        cls += " " + props.class;
    }
    if (props.visible === false) {
        cls += " " + "hidden";
    }
    return preact_1.h("div", { class: cls, style: props.style },
        props.title ? preact_1.h("span", null, props.title) : null,
        props.children);
}
exports.Alert = Alert;
//# sourceMappingURL=module.js.map
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vbW9kdWxlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBMkI7QUFJM0IsU0FBZ0IsS0FBSyxDQUFDLEtBT3JCO0lBQ0csSUFBSSxHQUFHLEdBQUcsT0FBTyxHQUFHLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUVoRCxJQUFJLEtBQUssQ0FBQyxJQUFJLEVBQUU7UUFDWixHQUFHLElBQUksR0FBRyxHQUFHLEtBQUssQ0FBQyxJQUFJLENBQUM7S0FDM0I7SUFFRCxJQUFJLEtBQUssQ0FBQyxLQUFLLEVBQUU7UUFDYixHQUFHLElBQUksR0FBRyxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUM7S0FDNUI7SUFFRCxJQUFJLEtBQUssQ0FBQyxPQUFPLEtBQUssS0FBSyxFQUFFO1FBQ3pCLEdBQUcsSUFBSSxHQUFHLEdBQUcsUUFBUSxDQUFDO0tBQ3pCO0lBRUQsT0FBTyxvQkFBSyxLQUFLLEVBQUUsR0FBRyxFQUFFLEtBQUssRUFBRSxLQUFLLENBQUMsS0FBSztRQUFHLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLHlCQUFPLEtBQUssQ0FBQyxLQUFLLENBQVEsQ0FBQyxDQUFDLENBQUMsSUFBSTtRQUFFLEtBQUssQ0FBQyxRQUFRLENBQU8sQ0FBQztBQUN4SCxDQUFDO0FBdkJELHNCQXVCQyJ9